import {apiBase} from 'api/base.js';

class CowshedAPI {
  index(farmId) {
    return apiBase.get(`/admin/cowshed?farm_id=${farmId}`);
  }

  show(farmId, id) {
    return apiBase.get(`/admin/cowshed/${id}?farm_id=${farmId}`);
  }

  create(farmId, params) {
    return apiBase.post('/admin/cowshed', params);
  }

  update(id, params) {
    return apiBase.put(`/admin/cowshed/${id}`, params);
  }

  delete(farmId, id) {
    const params = {farmId: farmId};
    return apiBase.delete(`/admin/cowshed/${id}`, params);
  }
}

export const cowshedAPI = new CowshedAPI();
